<template>
  <!-- <div align="center">
   <v-container  style="margin:1px">
    <a-card :bordered="false" style="max-width: 350px; width: 350px; height:500px">
      <a-row type="flex" justify="center">
        <a-col :span="24">
          <a-row type="flex" justify="center">
            <h2>สมัครสมาชิก ONE ID</h2>
          </a-row>
        </a-col>
        <a-col :span="24">
          <a-form
            id="components-form-demo-normal-login"
            :form="FormRegister"
            class="login-form"
            @submit="Register"
          >
            <a-form-item>
              <a-input
                size="large"
                v-decorator="[
                  'username',
                  { rules: [{ required: true, message: 'กรุณากรอกชื่อผู้ใช้งาน' }] },
                ]"
                placeholder="ชื่อผู้ใช้งาน*"
              >
                <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-tooltip placement="topLeft" overlay-class-name="numeric-input">
                <template slot="title">
                  <ul>
                    <li>- ตัวพิมพ์เล็กอย่างน้อยหนึ่งตัว</li>
                    <li>- ตัวพิมพ์ใหญ่อย่างน้อยหนึ่งตัว</li>
                    <li>- ตัวเลขอย่างน้อยหนึ่งตัว</li>
                    <li>- ขั้นต่ำ 8 อักขระ</li>
                  </ul>
                </template>
                <a-input-password
                  size="large"
                  v-decorator="[
                    'password',
                    { rules: [{ required: true, message: 'กรุณากรอกรหัสผ่าน' }] },
                  ]"
                  placeholder="รหัสผ่าน*"
                >
                  <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
                </a-input-password>
              </a-tooltip>
            </a-form-item>
            <a-form-item>
              <a-input
                size="large"
                v-decorator="[
                  'email',
                  { rules: [{ required: true, message: 'กรุณากรอกอีเมล' }] },
                ]"
                placeholder="อีเมล*"
              >
                <a-icon slot="prefix" type="mail" style="color: rgba(0,0,0,.25)" />
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input
                size="large"
                v-decorator="[
                  'phone',
                  { rules: [{ required: true, message: 'กรุณากรอกเบอร์โทรศัพท์' }] },
                ]"
                placeholder="หมายเลขโทรศัพท์"
                :max-length="12"
                v-mask="'###-###-####'"
              >
                <a-icon slot="prefix" type="mobile" style="color: rgba(0,0,0,.25)" />
              </a-input>
            </a-form-item>
            <a-button size="large" html-type="submit" class="login-form-button" style="background-color: #27AB9C; color: white; border-color: #27AB9C;" :disabled="checkClick">
              สมัครสมาชิก
            </a-button>
          </a-form>
        </a-col>
      </a-row>
    </a-card>
   </v-container>
  </div> -->
  <div>
    <!-- website -->
    <v-container v-if="!MobileSize && !IpadSize">
      <v-row justify="center" class="my-7">
        <v-card width="480px" height="100%" style="background: #FFFFFF; box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1); border-radius: 12px;">
          <v-card-text>
            <v-container>
              <v-form ref="Registerform" :lazy="lazy">
                <v-row dense justify="center" align-content="center" class="mt-4 mb-6">
                  <span style="font-weight: bold; font-size: 24px; line-height: 32px; color: #000000;">สมัครสมาชิก ONE ID</span>
                </v-row>
                <!-- <v-row dense justify="center" align-content="center" class="mt-4 mb-8 mx-6">
                  <span style="font-size: 14px; line-height: 22px; color: #000000;">
                    <span style="color: #D1392B;">*</span> การลงทะเบียนนี้ เป็นการลงทะเบียนโดยใช้ ONE ID <br/>
                    เพื่อความสะดวกและปลอดภัยในการเข้าสู่ระบบเมื่อท่านสมัครสมาชิก<br/>
                    เรียบร้อยแล้ว สามารถกดที่ปุ่ม “เข้าสู่ระบบด้วย ONE ID” <br/>
                    ในหน้าเข้าสู่ระบบได้เลย
                  </span>
                </v-row> -->
                <v-row no-gutters dense class="mx-8">
                  <!-- ชื่อผู้ใช้งาน -->
                  <v-col cols="12" md="12" sm="12">
                    <v-text-field v-model="username" placeholder="ชื่อผู้ใช้งาน" outlined dense required :rules="Rules.name"></v-text-field>
                    <!-- <a-input  size="large"   v-decorator="[ 'username', { rules: [{ required: true, message: 'กรุณากรอกชื่อผู้ใช้งาน' }] },  ]"    placeholder="ชื่อผู้ใช้งาน*"   >
                     <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
                    </a-input> -->
                  </v-col>
                  <!-- รหัสผ่าน -->
                  <v-col cols="12" md="12" sm="12">
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="password" placeholder="รหัสผ่าน" outlined dense required v-bind="attrs" v-on="on" :rules="Rules.password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1"></v-text-field>
                      </template>
                      <ul>
                        <li>ตัวพิมพ์เล็ก(a-z)อย่างน้อยหนึ่งตัว</li>
                        <li>ตัวพิมพ์ใหญ่(A-Z)อย่างน้อยหนึ่งตัว</li>
                        <li>ตัวเลขอย่างน้อยหนึ่งตัว</li>
                        <li>ขั้นต่ำ 8 อักขระ</li>
                      </ul>
                    </v-tooltip>
                  </v-col>
                  <!-- ยืนยันรหัสผ่าน -->
                  <v-col cols="12" md="12" sm="12">
                    <v-text-field v-model="confirmpassword" placeholder="ยืนยันรหัสผ่าน" outlined dense required :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :type="show2 ? 'text' : 'password'" @click:append="show2 = !show2" :rules="Rules.confirmPasswordRules.concat(passwordConfirmationRule)"></v-text-field>
                  </v-col>
                  <!-- อีเมล -->
                  <v-col cols="12" md="12" sm="12">
                    <v-text-field v-model="email" placeholder="อีเมล" outlined dense required  :rules="Rules.email"></v-text-field>
                  </v-col>
                  <!-- เบอร์โทรศัพท์ -->
                  <v-col cols="12" md="12" sm="12">
                    <v-text-field v-model="phone" placeholder="เบอร์โทรศัพท์" outlined dense required :rules="Rules.tel"  maxlength="10" oninput="this.value = this.value.replace(/[^0-9\s]/g, '').replace(/(\..*)\./g, '$1')"></v-text-field>
                  </v-col>
                  <!-- ปุ่มสมัครสมาชิก -->
                  <v-col cols="12" md="12" sm="12" class="mt-3">
                    <v-btn block rounded style="border-radius: 32px; font-size: 18px; font-weight: bold; line-height: 26px;" color="#27AB9C" dark elevation="6" @click="Register()" >สมัครสมาชิก</v-btn>
                  </v-col>
                  <!-- มีบัญชีอยู่แล้ว? ลงชื่อเข้าใช้ -->
                  <v-col cols="12" md="12" sm="12" class="mt-10 mb-6">
                    <v-row dense justify="center" align-content="center">
                      <span style="font-size: 16px; line-height: 24px;">มีบัญชีอยู่แล้ว? <span style="color: #1E90FF; cursor: pointer;" @click="link('Login')">ลงชื่อเข้าใช้</span></span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-row>
    </v-container>
    <!-- Ipad -->
    <v-container v-if="!MobileSize && IpadSize">
      <v-row justify="center" class="my-14">
        <v-card width="467px" height="100%" style="background: #FFFFFF; box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1); border-radius: 12px;">
          <v-card-text>
            <v-container>
              <v-form ref="Registerform" :lazy="lazy">
                <v-row dense justify="center" align-content="center" class="mt-4 mb-6">
                  <span style="font-weight: bold; font-size: 24px; line-height: 32px; color: #000000;">สมัครสมาชิก ONE ID</span>
                </v-row>
                <!-- <v-row dense justify="center" align-content="center" class="mt-4 mb-8 mx-6">
                  <span style="font-size: 14px; line-height: 22px; color: #000000;">
                    <span style="color: #D1392B;">*</span> การลงทะเบียนนี้ เป็นการลงทะเบียนโดยใช้ ONE ID <br/>
                    เพื่อความสะดวกและปลอดภัยในการเข้าสู่ระบบเมื่อท่านสมัครสมาชิก<br/>
                    เรียบร้อยแล้ว สามารถกดที่ปุ่ม “เข้าสู่ระบบด้วย ONE ID” <br/>
                    ในหน้าเข้าสู่ระบบได้เลย
                  </span>
                </v-row> -->
                <v-row no-gutters dense class="mx-8">
                  <!-- ชื่อผู้ใช้งาน -->
                  <v-col cols="12" md="12" sm="12">
                    <v-text-field v-model="username" placeholder="ชื่อผู้ใช้งาน" outlined dense required :rules="Rules.name"></v-text-field>
                  </v-col>
                  <!-- รหัสผ่าน -->
                  <v-col cols="12" md="12" sm="12">
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="password" placeholder="รหัสผ่าน" outlined dense required v-bind="attrs" v-on="on" :rules="Rules.password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1"></v-text-field>
                      </template>
                      <ul>
                        <li>ตัวพิมพ์เล็ก(a-z)อย่างน้อยหนึ่งตัว</li>
                        <li>ตัวพิมพ์ใหญ่(A-Z)อย่างน้อยหนึ่งตัว</li>
                        <li>ตัวเลขอย่างน้อยหนึ่งตัว</li>
                        <li>ขั้นต่ำ 8 อักขระ</li>
                      </ul>
                    </v-tooltip>
                  </v-col>
                  <!-- ยืนยันรหัสผ่าน -->
                  <v-col cols="12" md="12" sm="12">
                    <v-text-field v-model="confirmpassword" placeholder="ยืนยันรหัสผ่าน" outlined dense required :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :type="show2 ? 'text' : 'password'" @click:append="show2 = !show2" :rules="Rules.confirmPasswordRules.concat(passwordConfirmationRule)"></v-text-field>
                  </v-col>
                  <!-- อีเมล -->
                  <v-col cols="12" md="12" sm="12">
                    <v-text-field v-model="email" placeholder="อีเมล" outlined dense required  :rules="Rules.email"></v-text-field>
                  </v-col>
                  <!-- เบอร์โทรศัพท์ -->
                  <v-col cols="12" md="12" sm="12">
                    <v-text-field v-model="phone" placeholder="เบอร์โทรศัพท์" outlined dense required :rules="Rules.tel"  maxlength="10" oninput="this.value = this.value.replace(/[^0-9\s]/g, '').replace(/(\..*)\./g, '$1')"></v-text-field>
                  </v-col>
                  <!-- ปุ่มลงทะเบียน -->
                  <v-col cols="12" md="12" sm="12" class="mt-3">
                    <v-btn block rounded style="border-radius: 32px; font-size: 18px; font-weight: bold; line-height: 26px;" color="#27AB9C" dark elevation="6" @click="Register()">สมัครสมาชิก</v-btn>
                  </v-col>
                  <!-- มีบัญชีอยู่แล้ว? ลงชื่อเข้าใช้ -->
                  <v-col cols="12" md="12" sm="12" class="mt-10 mb-6">
                    <v-row dense justify="center" align-content="center">
                      <span style="font-size: 16px; line-height: 24px;">มีบัญชีอยู่แล้ว? <span style="color: #1E90FF; cursor: pointer;" @click="link('Login')">ลงชื่อเข้าใช้</span></span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-row>
    </v-container>
    <!-- App -->
    <v-container v-if="MobileSize">
      <v-row justify="center" class="my-6">
        <v-card width="480px" height="700px" style="background: #FFFFFF; box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1); border-radius: 12px;">
          <v-card-text>
            <v-container>
              <v-form ref="Registerform" :lazy="lazy">
                <v-row dense justify="center" align-content="center" class="mt-4 mb-6">
                  <span style="font-weight: bold; font-size: 24px; line-height: 32px; color: #000000;">ลงทะเบียน</span>
                </v-row>
                <!-- <v-row dense justify="center" align-content="center" class="mt-4 mb-8 mx-6">
                  <span style="font-size: 14px; line-height: 22px; color: #000000;">
                    <span style="color: #D1392B;">*</span> การลงทะเบียนนี้ เป็นการลงทะเบียนโดยใช้ ONE ID <br/>
                    เพื่อความสะดวกและปลอดภัยในการเข้าสู่ระบบเมื่อท่านสมัครสมาชิก<br/>
                    เรียบร้อยแล้ว สามารถกดที่ปุ่ม “เข้าสู่ระบบด้วย ONE ID” <br/>
                    ในหน้าเข้าสู่ระบบได้เลย
                    </span>
                </v-row> -->
                <v-row no-gutters dense class="mx-8">
                  <!-- ชื่อผู้ใช้งาน -->
                  <v-col cols="12" md="12" sm="12">
                    <v-text-field v-model="username" placeholder="ชื่อผู้ใช้งาน" outlined dense required :rules="Rules.name"></v-text-field>
                  </v-col>
                  <!-- รหัสผ่าน -->
                  <v-col cols="12" md="12" sm="12">
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="password" placeholder="รหัสผ่าน" outlined dense required v-bind="attrs" v-on="on" :rules="Rules.password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1"></v-text-field>
                      </template>
                      <ul>
                        <li>ตัวพิมพ์เล็ก(a-z)อย่างน้อยหนึ่งตัว</li>
                        <li>ตัวพิมพ์ใหญ่(A-Z)อย่างน้อยหนึ่งตัว</li>
                        <li>ตัวเลขอย่างน้อยหนึ่งตัว</li>
                        <li>ขั้นต่ำ 8 อักขระ</li>
                      </ul>
                    </v-tooltip>
                  </v-col>
                  <!-- ยืนยันรหัสผ่าน -->
                  <v-col cols="12" md="12" sm="12">
                    <v-text-field v-model="confirmpassword" placeholder="ยืนยันรหัสผ่าน" outlined dense required :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :type="show2 ? 'text' : 'password'" @click:append="show2 = !show2" :rules="Rules.confirmPasswordRules.concat(passwordConfirmationRule)"></v-text-field>
                  </v-col>
                  <!-- อีเมล -->
                  <v-col cols="12" md="12" sm="12">
                    <v-text-field v-model="email" placeholder="อีเมล" outlined dense required  :rules="Rules.email"></v-text-field>
                  </v-col>
                  <!-- เบอร์โทรศัพท์ -->
                  <v-col cols="12" md="12" sm="12">
                    <v-text-field v-model="phone" placeholder="เบอร์โทรศัพท์" outlined dense required :rules="Rules.tel"  maxlength="10" oninput="this.value = this.value.replace(/[^0-9\s]/g, '').replace(/(\..*)\./g, '$1')"></v-text-field>
                  </v-col>
                  <!-- ปุ่มลงทะเบียน -->
                  <v-col cols="12" md="12" sm="12">
                    <v-btn block rounded style="border-radius: 32px;" color="#00B500" dark elevation="6" @click="Register()">ลงทะเบียน</v-btn>
                  </v-col>
                  <!-- มีบัญชีอยู่แล้ว? ลงชื่อเข้าใช้ -->
                  <v-col cols="12" md="12" sm="12" class="mt-6">
                    <v-row dense justify="center" align-content="center">
                      <span style="font-size: 16px; line-height: 24px;">มีบัญชีอยู่แล้ว? <span style="color: #1E90FF; cursor: pointer;" @click="link('Login')">ลงชื่อเข้าใช้</span></span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// import axios from 'axios'
import { Encode, Decode } from '@/services'
export default {
  data () {
    return {
      show1: false,
      show2: false,
      overlay: false,
      confirmpassword: '',
      MaxLength: 10,
      telephone: '',
      lazy: false,
      tab: null,
      username: '',
      password: '',
      emailMarket: '',
      passwordMarket: '',
      checkClick: false,
      email: '',
      phone: '',
      items: [
        { header: 'เข้าสู่ระบบ' },
        { header: 'สมัครสมาชิก' }
      ],
      visibleLogin: false,
      visibleRegis: false,
      Rules: {
        empty: [v => !!v || 'กรุณาเลือกข้อมูล'],
        name: [
          v => !!v || 'กรุณากรอกชื่อผู้ใช้งาน',
          v => /^[A-Za-z0-9\s]+$/.test(v) || 'กรุณากรอกเฉพาะภาษาอังกฤษและตัวเลขเท่านั้น',
          v => v.length >= 6 || 'กรุณากรอกให้ครบ 6 อักขระหรือมากกว่านั้น'
        ],
        password: [
          v => !!v || 'กรุณากรอกรหัสผ่าน',
          v => /^[A-Za-z0-9\s]+$/.test(v) || 'กรุณากรอกเฉพาะภาษาอังกฤษและตัวเลขเท่านั้น',
          v => v.length >= 8 || 'กรุณากรอกให้ครบ 8 อักขระหรือมากกว่านั้น'
        ],
        email: [
          v => !!v || 'กรุณากรอกอีเมล',
          v => /.+@.+\..+/.test(v) || 'กรุณากรอกอีเมลให้ถูกต้อง',
          v => /^[A-Za-z0-9_@.,/#&+-\s]+$/.test(v) || 'กรุณากรอกเฉพาะภาษาอังกฤษ',
          v => /^\S*$/.test(v) || 'ห้ามใส่ช่องว่างในอีเมล'
        ],
        tel: [
          v => !!v || 'กรุณากรอกเบอร์โทรศัพท์'
        ],
        confirmPasswordRules: [
          v => !!v || 'กรุณากรอกรหัสผ่าน'
        ]
      },
      // Rules: {
      //   empty: [v => !!v || 'กรุณาเลือกข้อมูล'],
      //   name: [
      //     v => !!v || 'กรุณากรอกชื่อผู้ใช้งาน'
      //   ],
      //   password: [
      //     v => !!v || 'กรุณากรอกรหัสผ่าน'
      //   ],
      //   email: [
      //     v => !!v || 'กรุณากรอกอีเมล'
      //   ],
      //   tel: [
      //     v => !!v || 'กรุณากรอกเบอร์โทรศัพท์'
      //   ]
      // },
      form: this.$form.createForm(this, { name: 'normal_login' }),
      FormRegister: this.$form.createForm(this, { name: 'register' })
    }
  },
  computed: {
    passwordConfirmationRule () {
      return () =>
        this.password === this.confirmpassword || 'กรุณาใส่รหัสผ่านให้ตรงกัน'
    },
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    }
  },
  created () {
    this.$EventBus.$emit('main', this.$route.name)
    this.$EventBus.$emit('checkpage', this.$route.name)
    var CurrentPath = this.$router.currentRoute.path
    localStorage.setItem('CurrentPath', CurrentPath)
    this.$EventBus.$on('closeModalLogin', this.closeModalLogin)
    this.$EventBus.$on('openModalLogin', this.openModalLogin)
    this.$EventBus.$on('closeModalRegister', this.closeModalRegister)
    this.$EventBus.$on('openModalRegister', this.openModalRegister)
  },
  methods: {
    link (val) {
      this.$router.replace({ path: `/${val}` }).catch(() => {})
    },
    // Register (e) {
    //   e.preventDefault()
    //   this.FormRegister.validateFields(async (err, values) => {
    //     // console.log(err, values)
    //     if (!err) {
    //       console.log('ก่อนยิง api', Object.prototype.hasOwnProperty.call(localStorage, 'oneData'))
    //       this.checkClick = false
    //       var checkonedata = Object.prototype.hasOwnProperty.call(localStorage, 'oneData')
    //       if (checkonedata) {
    //         var onedata = JSON.parse(Decode.decode(localStorage.getItem('oneData')))
    //         onedata.CurrentPath = this.$router.currentRoute.path
    //         await this.APIRegister(values)
    //       } else {
    //         onedata = {}
    //         onedata.CurrentPath = this.$router.currentRoute.path
    //         localStorage.setItem('oneData', Encode.encode(onedata))
    //         await this.APIRegister(values)
    //       }
    //     }
    //   })
    // },
    async Register () {
      if (this.$refs.Registerform.validate(true)) {
        this.$store.commit('openLoader')
        var checkonedata = Object.prototype.hasOwnProperty.call(localStorage, 'oneData')
        if (checkonedata) {
          var checkMail = {
            email: this.email
          }
          var ResponseCheckMail = await this.axios.post(`${process.env.VUE_APP_BACK_END}api/check_email_one_id`, checkMail)
          // console.log('ResponseCheckMail =========>', ResponseCheckMail)
          if (ResponseCheckMail.data.code !== 400 && ResponseCheckMail.data.message !== 'email duplicate') {
            var onedata = JSON.parse(Decode.decode(localStorage.getItem('oneData')))
            onedata.CurrentPath = this.$router.currentRoute.path
            await this.APIRegister()
          } else {
            this.$store.commit('closeLoader')
            this.$swal.fire({ text: 'อีเมลนี้มีอยู่ในระบบแล้ว กรุณาใช้อีเมลอื่น', icon: 'error', timer: 2500, showConfirmButton: false })
          }
        } else {
          var checkMail1 = {
            email: this.email
          }
          var ResponseCheckMail1 = await this.axios.post(`${process.env.VUE_APP_BACK_END}api/check_email_one_id`, checkMail1)
          // console.log('ResponseCheckMail1 =========>', ResponseCheckMail1)
          if (ResponseCheckMail1.data.code !== 400 && ResponseCheckMail1.data.message !== 'email duplicate') {
            onedata = {}
            onedata.CurrentPath = this.$router.currentRoute.path
            localStorage.setItem('oneData', Encode.encode(onedata))
            await this.APIRegister()
          } else {
            this.$store.commit('closeLoader')
            this.$swal.fire({ text: 'อีเมลนี้มีอยู่ในระบบแล้ว กรุณาใช้อีเมลอื่น', icon: 'error', timer: 2500, showConfirmButton: false })
          }
        }
      }
    },
    async APIRegister () {
      var data = {
        username: this.username,
        password: this.password,
        re_password: this.confirmpassword,
        email: this.email,
        mobile_no: this.phone
      }
      // console.log(data)
      var RegisterData = await this.axios.post(`${process.env.VUE_APP_BACK_END}api/register_and_login`, data)
      if (RegisterData.data.result === 'SUCCESS') {
        this.$swal.fire({ text: `${RegisterData.data.message}`, icon: 'success', timer: 2500, showConfirmButton: false })
        this.username = ''
        this.password = ''
        this.email = ''
        this.phone = ''
        var onedata = JSON.parse(Decode.decode(localStorage.getItem('oneData')))
        onedata.user = RegisterData.data.data
        var dataRole = {
          role: 'ext_buyer'
        }
        localStorage.setItem('roleUser', JSON.stringify(dataRole))
        localStorage.setItem('oneData', Encode.encode(onedata))
        // window.location.reload()
        window.location.assign('/')
      } else if (RegisterData.data.message === 'Your username duplicate') {
        this.$store.commit('closeLoader')
        this.$swal.fire({ text: 'ชื่อผู้ใช้งานนี้มีอยู่ในระบบแล้ว กรุณาใช้ชื่อผู้ใช้งานอื่น', icon: 'error', timer: 2500, showConfirmButton: false })
      } else if (RegisterData.data.message === 'Parameter is missing.') {
        this.$store.commit('closeLoader')
        this.$swal.fire({ text: 'ข้อมูลไม่ครบ กรุณาตรวจสอบข้อมูลอีกครั้ง', icon: 'error', timer: 2500, showConfirmButton: false })
      } else {
        this.$store.commit('closeLoader')
        this.$swal.fire({ text: `${RegisterData.data.message}`, icon: 'error', timer: 2500, showConfirmButton: false })
      }
      // var RegisterData = await this.axios.post(`${process.env.VUE_APP_CONNECT_REGISTER_AND_LOGIN}`, data)
      // if (RegisterData.data.result === 'SUCCESS') {
      //   this.$swal.fire({ text: `${RegisterData.data.message}`, icon: 'success', timer: 2500, showConfirmButton: false })
      //   var onedata = {}
      //   onedata.user = RegisterData.data.data
      //   var PathRedirect = localStorage.getItem('CurrentPath')
      //   if (PathRedirect === '/' || PathRedirect === '/') {
      //     PathRedirect = ''
      //   } else if (PathRedirect === '/Register' || PathRedirect === '/Login') {
      //     PathRedirect = ''
      //   }
      //   var dataRole = {
      //     role: 'ext_buyer'
      //   }
      //   localStorage.setItem('roleUser', JSON.stringify(dataRole))
      //   localStorage.setItem('oneData', Encode.encode(onedata))
      //   this.$refs.Registerform.resetValidation()
      //   this.$refs.Registerform.reset()
      //   this.$store.commit('closeLoader')
      //   window.location.assign(`${process.env.VUE_APP_DOMAIN}${PathRedirect}`)
      //   // this.$router.push({ path: `${PathRedirect}` }).catch(() => {})
      // } else if (RegisterData.data.message === 'Your username duplicate.') {
      //   this.$store.commit('closeLoader')
      //   this.$swal.fire({ text: 'ชื่อผู้ใช้นี้ถูกใช้ไปแล้ว กรุณาเปลี่ยนชื่อผู้ใช้ใหม่ครับ', icon: 'error', timer: 2500, showConfirmButton: false })
      // } else {
      //   this.$store.commit('closeLoader')
      //   this.$swal.fire({ text: 'กรุณาทำรายการใหม่อีกครั้งครับ', icon: 'error', timer: 2500, showConfirmButton: false })
      // }
    },
    //  APIRegister =====>  ของเก่า
    // async APIRegister (values) {
    //   var data = {
    //     username: values.username,
    //     password: values.password,
    //     email: values.email,
    //     mobile_no: values.phone.replace(/-/g, '')
    //   }
    //   // console.log(data)
    //   var RegisterData = await this.axios.post(`${process.env.VUE_APP_BACK_END}api/register_and_login`, data)
    //   if (RegisterData.data.result === 'SUCCESS') {
    //     this.$swal.fire({ text: `${RegisterData.data.message}`, icon: 'success', timer: 2500, showConfirmButton: false })
    //     this.username = ''
    //     this.password = ''
    //     this.email = ''
    //     this.phone = ''
    //     var onedata = JSON.parse(Decode.decode(localStorage.getItem('oneData')))
    //     onedata.user = RegisterData.data.data
    //     var dataRole = {
    //       role: 'ext_buyer'
    //     }
    //     localStorage.setItem('roleUser', JSON.stringify(dataRole))
    //     localStorage.setItem('oneData', Encode.encode(onedata))
    //     window.location.reload()
    //   } else {
    //     this.$swal.fire({ text: `${RegisterData.data.message}`, icon: 'error', timer: 2500, showConfirmButton: false })
    //   }
    // },
    // async Login () {
    //   console.log('this.$router.currentRoute.params.data', this.$router.currentRoute.path)
    //   var onedata = {}
    //   onedata.CurrentPath = this.$router.currentRoute.path
    //   console.log(onedata)
    //   localStorage.setItem('oneData', Encode.encode(onedata))
    //   console.log('ข้อมูล local', JSON.parse(Decode.decode(localStorage.getItem('oneData'))))
    //   window.location.assign(`${process.env.VUE_APP_REDIRECT}`)
    // },
    async LoginMarket (e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          var data = {
            email: values.emailMarket,
            password: values.passwordMarket
          }
          // console.log(data)
          var LoginData = await this.axios.post(`${process.env.VUE_APP_BACK_END}api/login_market`, data)
          // console.log(LoginData)
          if (LoginData.data.result === 'SUCCESS') {
            this.$swal.fire({ text: `${LoginData.data.message}`, icon: 'success', timer: 2500, showConfirmButton: false })
            values.emailMarket = ''
            values.passwordMarket = ''
            this.form.resetFields()
            var dataRole = {
              role: 'ext_buyer'
            }
            localStorage.setItem('roleUser', JSON.stringify(dataRole))
            var onedata = {}
            // console.log('onedata ====>', onedata)
            onedata.user = LoginData.data.data
            localStorage.setItem('oneData', Encode.encode(onedata))
            window.location.reload()
          } else {
            this.$swal.fire({ text: `${LoginData.data.message}`, icon: 'error', timer: 2500, showConfirmButton: false })
            this.passwordMarket = ''
            this.openModalLogin()
          }
        }
      })
    },
    closeModalLogin () {
      this.visibleLogin = false
    },
    openModalLogin () {
      this.visibleLogin = true
    },
    closeModalRegister () {
      this.visibleRegis = false
    },
    openModalRegister () {
      this.visibleRegis = true
    },
    showRegister () {
      this.visibleRegis = true
      this.visibleLogin = false
    }
  }
}
</script>

<style scoped>
.borderButtomText {
  margin-bottom: -30px
}
</style>
<style>
.numeric-input .ant-tooltip-inner {
  min-width: 50px;
  min-height: 35px;
}
.numeric-input .numeric-input-title {
  font-size: 14px;
}
.ant-popover-inner-content{
  padding: 0;
}
#components-form-demo-normal-login .login-form {
  max-width: 350px;
}
#components-form-demo-normal-login .login-form-forgot {
  float: right;
  margin-bottom: 10px;
  margin-top: -15px;
}
#components-form-demo-normal-login .login-form-button {
  width: 100%;
}
</style>
